import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    toCopy: String,
  };

  copyText = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    await navigator.clipboard.writeText(this.toCopyValue);

    this.setButtonCopiedState();
    this.dispatch('textCopied', {
      detail: { copiedValue: this.toCopyValue },
    });
  };

  setButtonCopiedState = () => {
    this.element.setAttribute('data-copied', 'true');
  };
}
